import React from "react";
import {Router} from "react-router-dom";
import {createBrowserHistory} from "history";
import {create} from "jss";
import rtl from "jss-rtl";
import MomentUtils from "@date-io/moment";
import {SnackbarProvider} from "notistack";
import {jssPreset, StylesProvider, ThemeProvider} from "@material-ui/core";
import {MuiPickersUtilsProvider} from "@material-ui/pickers";
import GlobalStyles from "src/components/GlobalStyles";
import ScrollReset from "src/components/ScrollReset";
import CookiesNotification from "src/views/notifications/CookiesNotification";
import SettingsNotification from "src/views/notifications/SettingsNotification";
import LanguageSelectionDialog from "src/views/notifications/LanguageSelectionDialog";
// import GoogleAnalytics from 'src/components/GoogleAnalytics';
import {AuthProvider} from "src/contexts/AuthContext";
import useSettings from "src/hooks/useSettings";
import {createCustomTheme} from "src/theme";
import routes, {renderRoutes} from "src/routes";

const jss = create({plugins: [...jssPreset().plugins, rtl()]});
const history = createBrowserHistory();

const App = () => {
    const {settings} = useSettings();

    const theme = createCustomTheme({
        direction: settings.direction,
        responsiveFontSizes: settings.responsiveFontSizes,
        theme: settings.theme
    });

    return (
        <ThemeProvider theme={theme}>
            <StylesProvider jss={jss}>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                    <SnackbarProvider dense maxSnack={3}>
                        <Router history={history}>
                            <AuthProvider>
                                <GlobalStyles/>
                                <ScrollReset/>
                                {/*<GoogleAnalytics />*/}
                                <CookiesNotification/>
                                <SettingsNotification/>
                                <LanguageSelectionDialog/>
                                {renderRoutes(routes)}
                            </AuthProvider>
                        </Router>
                    </SnackbarProvider>
                </MuiPickersUtilsProvider>
            </StylesProvider>
        </ThemeProvider>
    );
};

export default App;
